/* Progressive visual improvements; never rewrites product data, URLs or SEO metadata. */
(() => {
 const start=()=>{
  if(document.body.classList.contains('refinement-contact-page')){
   const copy=document.querySelector('.premium-contact-copy'),main=document.querySelector('#MainContent');
   if(copy&&main&&!main.querySelector('.refinement-contact-details')){const section=document.createElement('div');section.className='refinement-contact-details';section.append(copy);main.append(section);}
  }
  if(document.body.classList.contains('refinement-shipping')){
   const body=document.querySelector('.shopify-policy__body .rte')||document.querySelector('.shopify-policy__body');
   if(!body||body.dataset.refined)return;body.dataset.refined='true';
   const headings=new Set(['UK DELIVERY','DELIVERY ADDRESS','DELIVERY DELAYS','DISPATCH AND DELIVERY','DELIVERY TIMES','ORDER TRACKING','LOST OR DELAYED ORDERS','DAMAGED ORDERS','INTERNATIONAL DELIVERY','CUSTOMS AND IMPORT CHARGES','CONTACT','CONTACT US']);
   [...body.querySelectorAll('p')].forEach(p=>{const text=p.textContent.trim();
    if(text==='SHIPPING POLICY'||/^Last updated:\s*7 August 2026\.?$/i.test(text)){p.remove();return;}
    if(headings.has(text)){const h=document.createElement('h2');h.textContent=text==='UK DELIVERY'?'UK delivery':text.charAt(0)+text.slice(1).toLowerCase();p.replaceWith(h);}
    if(text==='Free standard UK delivery is available when you spend £60 or more.')p.classList.add('refinement-shipping-summary');
   });
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
